import parseDate from "~/kernel/dateTime/parseDate";
import transform from "~/kernel/objects/transform";
import type SerializeType from "~/kernel/server/SerializeType";
import type { LoaderData } from "./route";
import type { CompanyPageReviewComment } from "./CompanyPageReview";

export default function deserializeReview(
  review: SerializeType<LoaderData["reviews"]["data"][number]>,
) {
  return transform(review, {
    createdAt: parseDate,
    comments: (comments) => comments.map(deserializeReviewComment),
  });
}

function deserializeReviewComment(
  comment: SerializeType<CompanyPageReviewComment>,
) {
  return transform(comment, { createdAt: parseDate });
}
